enum RecentActivityType {
  ELClaim = 'Claim',
  ELFIClaim = 'ELFIClaim',
  ELMigration = 'ELMigration',
  ELFIMigration = 'ELFIMigration',
  Deposit = 'Deposit',
  Withdraw = 'Withdraw',
  Claim = 'Claim',
  ELStakingWithdraw = 'ELStakingWithdraw',
  ELFIStakingWithdraw = 'ELFIStakingWithdraw',
  ELStake = 'ELStake',
  ELFIStake = 'ELFIStake',
  Approve = 'Approve',
  Idle = 'Idle',
  LPMigration = 'LPMigration',
  PurchasedNFT = 'PurchasedNFT',
}

export default RecentActivityType
